export default __webpack_public_path__ + "static/media/feature-address.915ce22e.svg";